import { render, staticRenderFns } from "./UpgradeAssignments.vue?vue&type=template&id=90a3e256&"
import script from "./UpgradeAssignments.vue?vue&type=script&lang=js&"
export * from "./UpgradeAssignments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports